export const seatGroupIdsSelector = state => state.seatGroupsReducer.seatGroupIds;
